import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
import axios from "axios";
import { BASE_URL } from "../api";
import { getApiHeaders } from "../utils/helpers";
import { useHandleError } from "../hooks/useHandleError";
import Loader from "../component/Loader";
import MessageToster from "../component/MessageToster";
import { validateChainAddress } from "../utils/addressValidator";
import CommonTable from "../component/CommonTable";

export default function WithdrawTether() {
  const navigate = useNavigate();
  const handleError = useHandleError();
  const mid = sessionStorage.getItem("mid");
  const [searchParams] = useSearchParams();
  const COIN_TYPE = searchParams.get("coin" || "");
  const paymentMethod = `Tether ${COIN_TYPE}`;
  const [chainWalletDetail, setChainWalletDetail] = useState([]);
  const [loading, setLoading] = useState(false);

  const [fromAccount, setFromAccount] = useState("");
  const [amount, setAmount] = useState("");
  const [address, setAddress] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [isLocked, setIsLocked] = useState(false);

  const [errors, setErrors] = useState({
    fromAccount: "",
    amount: "",
    address: "",
    otp: "",
  });

  useEffect(() => {
    getChainWalletDetails();
  }, []);

  const getChainWalletDetails = async () => {
    setLoading(true);

    try {
      const res = await axios.get(
        `${BASE_URL}/deposit_withdraw_general/chain_wallet_available_balance`,
        { headers: getApiHeaders() }
      );

      if (res.data.code === 200) {
        setChainWalletDetail(Array.isArray(res.data.data) ? res.data.data : []);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "amount") {
      if (!/^\d*\.?\d*$/.test(value)) return;
    }

    if (name === "otp") {
      if (!/^\d*$/.test(value)) return;
    }

    if (name === "fromAccount") setFromAccount(value);
    if (name === "amount") setAmount(value);
    if (name === "address") setAddress(value);
    if (name === "otp") setOtp(value);

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateWithdraw = () => {
    const addressError = validateChainAddress(COIN_TYPE, address);

    let newErrors = { fromAccount: "", amount: "", address: "" };
    let isError = false;

    if (!fromAccount) {
      newErrors.fromAccount = "Please select from account.";
      isError = true;
    }

    const amt = Number(amount);

    if (!amount) {
      newErrors.amount = "Please enter withdrawal amount.";
      isError = true;
    } else if (amt < 1) {
      newErrors.amount = "Minimum withdrawal is 1 USDT.";
      isError = true;
    }

    const selectedWallet = chainWalletDetail.find(
      (w) => w.address.trim() === String(fromAccount).trim()
    );

    const availableBalance = selectedWallet
      ? Number(selectedWallet.balance)
      : 0;

    if (!isError && amt > availableBalance) {
      newErrors.amount = `Insufficient balance. Available: ${availableBalance} USDT`;
      isError = true;
    }

    if (addressError) {
      newErrors.address = addressError;
      isError = true;
    }

    setErrors(newErrors);
    return !isError;
  };

  const beforeWithdraw = async () => {
    const isValid = validateWithdraw();
    if (!isValid) return;

    const payload = {
      mid: Number(mid),
      chain_type: COIN_TYPE,
      withdrawal_amount: Number(amount),
    };

    setLoading(true);
    try {
      const res = await axios.post(
        `${BASE_URL}/withdraw/before_withdraw`,
        payload,
        { headers: getApiHeaders() }
      );
      // const res = await axios.post(`http://192.168.29.119:8001/withdraw/before_withdraw`, payload, { headers: getApiHeaders() });

      if (res.data.code === 200) {
        setShowOtp(true);
        setIsLocked(true);
        MessageToster("success", "OTP sent to your email");
      } else {
        MessageToster("error", res.data.message);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const createWithdrawRequest = async () => {
    // if (!otp) return MessageToster("error", "Please Enter OTP.");
    if (!otp) {
      setErrors({ otp: "Please enter OTP." });
      return;
    }

    if (!/^\d+$/.test(otp)) {
      setErrors({ otp: "OTP must contain only numbers." });
      return;
    }

    setLoading(true);

    const payload = {
      mid: Number(mid),
      otp: Number(otp),
      from_address: fromAccount,
      to_address: address,
      amount: Number(amount),
      chain_type: COIN_TYPE,
      token_symbol: "USDT",
    };

    try {
      const res = await axios.post(
        `${BASE_URL}/withdraw/create_withdraw_request`,
        payload,
        { headers: getApiHeaders() }
      );
      // const res = await axios.post(`http://192.168.29.119:8001/withdraw/create_withdraw_request`, payload, { headers: getApiHeaders() });

      if (res.data.code === 200) {
        MessageToster("success", res.data.message);
        navigate("/withdraw");
      } else {
        MessageToster("error", res.data.message);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const getCoinImage = (coin) => {
    switch (coin) {
      case "BEP20 USDT":
        return "/assets/images/deposit/Tether_BEP20_USDT.svg";
      case "TRC20 USDT":
        return "/assets/images/deposit/Tether_TRC20_USDT.svg";
      default:
        return "/assets/images/deposit/Tether.svg";
    }
  };

  const filteredWallets = Array.isArray(chainWalletDetail)
    ? chainWalletDetail.filter((item) => item?.cointype === COIN_TYPE)
    : [];

  return (
    <>
      <div id="layout-wrapper">
        {loading && <Loader />}
        <Topbar />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* start page title */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h2 className="fw-700 mb-sm-0">Withdraw</h2>
                  </div>
                </div>
              </div>
              {/* end page title */}

              <div className="row">
                <div className="col-xl-8">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-12 mb-3">
                          <div className="hstack justify-content-between gap-2 flex-wrap">
                            <img
                              // src="assets/images/deposit/Tether.svg"
                              src={getCoinImage(COIN_TYPE)}
                              alt="product-img"
                              title="product-img"
                              width={50}
                            />
                            <button
                              type="Submit"
                              className="btn btn-primary px-sm-4 px-2"
                              onClick={() => navigate("/withdraw")}
                            >
                              Change Payment Method
                            </button>
                          </div>
                        </div>
                        <div className="col-lg-12 mb-4">
                          <div className="d-flex gap-3 align-items-center flex-wrap">
                            <div className="text-primary">
                              <h4 className="card-title mb-0">
                                Payment Process{" "}
                                {/* <span className="text-danger">*</span> */}
                              </h4>
                            </div>
                            {/* <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name=""
                                    id="inlineRadio2"
                                    defaultValue="option2"
                                    defaultChecked=""
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="inlineRadio2"
                                  >
                                    Account
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name=""
                                    id="inlineRadio2"
                                    defaultValue="option2"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="inlineRadio2"
                                  >
                                    Wallet
                                  </label>
                                </div> */}
                            {/* <div className="text-primary mr-5">
                                  <h4 className="card-title mb-0">
                                    Currency
                                    <span className="text-danger">*</span>
                                  </h4>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name=""
                                    id="inlineRadio2"
                                    defaultValue="option2"
                                    defaultChecked={true}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="inlineRadio2"
                                  >
                                    USDT
                                  </label>
                                </div> */}
                          </div>
                          <div className="d-flex gap-3 align-items-center flex-wrap mt-3">
                            <div className="text-primary">
                              <h4 className="card-title mb-0">
                                Currency
                                {/* <span className="text-danger">*</span> */}
                              </h4>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name=""
                                id="inlineRadio2"
                                defaultValue="option2"
                                defaultChecked={true}
                              />
                              <label
                                className="form-check-label notranslate"
                                htmlFor="inlineRadio2"
                                translate="no"
                              >
                                USDT
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-6 col-sm-6 mb-3">
                          <div>
                            <label className="form-label">
                              Payment Method
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={paymentMethod}
                              disabled
                            />
                            {/* <select className="form-select" name="select">
                                  <option value="Tether USD (USDT TRC20)">
                                    Tether USD (USDT TRC20)
                                  </option>
                                  <option value="Wallet">Wallet</option>
                                </select> */}
                          </div>
                        </div>
                        <div className="col-xl-6 col-sm-6 mb-3">
                          <div>
                            <label className="form-label">
                              From Account<span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-select"
                              name="fromAccount"
                              value={fromAccount}
                              onChange={handleChange}
                              // onChange={(e) => setFromAccount(e.target.value)}
                              disabled={isLocked}
                            >
                              <option value="" disabled hidden>
                                Select From Account
                              </option>
                              {filteredWallets.length > 0 ? (
                                filteredWallets.map((item, index) => (
                                  <option key={index} value={item.address}>
                                    {item.cointype} - Balance: {item.balance}
                                    {/* ({item.cointype}) - [{item.address}] - Balance: {item.balance} */}
                                  </option>
                                ))
                              ) : (
                                <option value="" disabled>
                                  No Account Found
                                </option>
                              )}
                            </select>
                            {errors.fromAccount && (
                              <p className="text-danger mb-0">
                                {errors.fromAccount}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-6 col-sm-6 mb-3">
                          <div>
                            <label className="form-label">
                              Amount (In USD)
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Amount (In USD)"
                              name="amount"
                              value={amount}
                              onChange={handleChange}
                              // onChange={(e) => setAmount(e.target.value)}
                              disabled={isLocked}
                            />
                            {errors.amount && (
                              <p className="text-danger mb-0">
                                {errors.amount}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-6 col-sm-6 mb-3">
                          <div>
                            <label className="form-label">
                              To External Wallet Address{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Wallet Address"
                              name="address"
                              value={address}
                              onChange={handleChange}
                              // onChange={(e) => setAddress(e.target.value)}
                              disabled={isLocked}
                            />
                            {errors.address && (
                              <p className="text-danger mb-0">
                                {errors.address}
                              </p>
                            )}
                            {/* <input
                                  className="form-control"
                                  type="text"
                                  id="example-date-input"
                                  placeholder="Wallet Address"
                                /> */}
                          </div>
                        </div>
                        {showOtp && (
                          <div className="col-xl-6 mb-3">
                            <label className="form-label">
                              Enter OTP <span className="text-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Enter OTP"
                              name="otp"
                              value={otp}
                              onChange={handleChange}
                              maxLength={6}
                            />
                            {errors.otp && (
                              <p className="text-danger">{errors.otp}</p>
                            )}
                          </div>
                        )}
                        <div className="col-12 mb-0">
                          {!showOtp ? (
                            <button
                              className="btn btn-primary"
                              onClick={beforeWithdraw}
                            >
                              Submit
                            </button>
                          ) : (
                            <button
                              className="btn btn-success"
                              onClick={createWithdrawRequest}
                            >
                              Confirm Withdrawal
                            </button>
                          )}
                        </div>

                        {/* <div className="col-12 mb-3">
                              <button
                                type="Submit"
                                className="btn btn-primary px-4"
                              >
                                Submit
                              </button>
                            </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-12">
                          <h4 className="card-title mb-4">Transfer Details</h4>
                          <div className="table-responsive">
                            <CommonTable
                              hideHeader={true}
                              columns={[
                                { accessor: "label", render: (row) => <th>{row.label}</th> },
                                { accessor: "value", className: "bg-light-subtle", render: (row) => row.value }
                              ]}
                              data={[
                                { label: "Withdrawal Processing Time", value: "24 Hours" },
                                { label: "Currencies", value: "USD" },
                                { label: "Minimum Withdrawal", value: "20" },
                                { label: "Maximum Withdrawal", value: "10000" }
                              ]}
                              tableClassName="table border align-middle mb-0 table-nowrap"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* container-fluid */}
          </div>

          {/* End Page-content */}
          <Footer />
        </div>
      </div>
    </>
  );
}

// import React, { useEffect, useState } from "react";
// import { Link, useNavigate, useSearchParams } from "react-router-dom";
// import Sidebar from "../component/Sidebar";
// import Topbar from "../component/Topbar";
// import Footer from "../component/Footer";
// import axios from "axios";
// import { BASE_URL } from "../api";
// import { getApiHeaders } from "../utils/helpers";
// import { useHandleError } from "../hooks/useHandleError";
// import Loader from "../component/Loader";
// import MessageToster from "../component/MessageToster";
// import { validateChainAddress } from "../utils/addressValidator";

// export default function WithdrawTether() {
//   const navigate = useNavigate();
//   const handleError = useHandleError();
//   const mid = sessionStorage.getItem("mid");
//   const [searchParams] = useSearchParams();
//   const COIN_TYPE = searchParams.get("coin" || "");
//   const paymentMethod = `Tether ${COIN_TYPE}`
//   const [chainWalletDetail, setChainWalletDetail] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [fromAccount, setFromAccount] = useState("");
//   const [amount, setAmount] = useState("");
//   const [address, setAddress] = useState("");
//   const [otp, setOtp] = useState("");
//   const [showOtp, setShowOtp] = useState(false);
//   const [isLocked, setIsLocked] = useState(false);

//   const [errors, setErrors] = useState({
//     fromAccount: "",
//     amount: "",
//     address: "",
//     otp: ""
//   });

//   useEffect(() => { getChainWalletDetails() }, []);

//   const getChainWalletDetails = async () => {
//     const payload = {
//       mid: Number(mid)
//     };
//     setLoading(true);

//     try {
//       const res = axios.post(`${BASE_URL}/deposit_withdraw_general/chain_wallet_available_balance`, payload, { headers: getApiHeaders() });

//       if (res.data.code === 200) {
//         setChainWalletDetail(res.data.data);
//       }
//     } catch (error) {
//       handleError(error);
//     } finally {
//       setLoading(false);
//     }

//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "amount") {
//       if (!/^\d*\.?\d*$/.test(value)) return;
//     }

//     if (name === "otp") {
//       if (!/^\d*$/.test(value)) return;
//     }

//     if (name === "fromAccount") setFromAccount(value);
//     if (name === "amount") setAmount(value);
//     if (name === "address") setAddress(value);
//     if (name === "otp") setOtp(value);

//     setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const validateWithdraw = () => {
//     const addressError = validateChainAddress(COIN_TYPE, address);

//     let newErrors = { fromAccount: "", amount: "", address: "" };
//     let isError = false;

//     if (!fromAccount) {
//       newErrors.fromAccount = "Please select from account.";
//       isError = true;
//     }

//     const amt = Number(amount);

//     if (!amount) {
//       newErrors.amount = "Please enter withdrawal amount.";
//       isError = true;
//     } else if (amt < 1) {
//       newErrors.amount = "Minimum withdrawal is 1 USDT.";
//       isError = true;
//     }

//     const selectedWallet = chainWalletDetail.find(
//       (w) => w.address.trim() === String(fromAccount).trim()
//     );

//     const availableBalance = selectedWallet ? Number(selectedWallet.balance) : 0;

//     if (!isError && amt > availableBalance) {
//       newErrors.amount = `Insufficient balance. Available: ${availableBalance} USDT`;
//       isError = true;
//     }

//     if (addressError) {
//       newErrors.address = addressError;
//       isError = true;
//     }

//     setErrors(newErrors);
//     return !isError;
//   };

//   const beforeWithdraw = async () => {

//     const isValid = validateWithdraw();
//     if (!isValid) return;

//     const payload = {
//       mid: Number(mid),
//       chain_type: COIN_TYPE,
//       withdrawal_amount: Number(amount)
//     };

//     setLoading(true);
//     try {
//       const res = await axios.post(`${BASE_URL}/withdraw/before_withdraw`, payload, { headers: getApiHeaders() });

//       if (res.data.code === 200) {
//         setShowOtp(true);
//         setIsLocked(true);
//         MessageToster("success", "OTP sent to your email");
//       } else {
//         MessageToster("error", res.data.message);
//       };
//     } catch (error) {
//       handleError(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const createWithdrawRequest = async () => {
//     if (!otp) {
//       setErrors({ otp: "Please enter OTP." });
//       return;
//     };

//     if (!/^\d+$/.test(otp)) {
//       setErrors({ otp: "OTP must contain only numbers." });
//       return;
//     };

//     setLoading(true);

//     const payload = {
//       mid: Number(mid),
//       otp: Number(otp),
//       from_address: fromAccount,
//       to_address: address,
//       amount: Number(amount),
//       chain_type: COIN_TYPE,
//       token_symbol: "USDT"
//     };

//     try {
//       const res = await axios.post(`${BASE_URL}/withdraw/create_withdraw_request`, payload, { headers: getApiHeaders() });

//       if (res.data.code === 200) {
//         MessageToster("success", res.data.message);
//         navigate("/withdraw");
//       } else {
//         MessageToster("error", res.data.message);
//       }
//     } catch (error) {
//       handleError(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getCoinImage = (coin) => {
//     switch (coin) {
//       case "BEP20 USDT":
//         return "/assets/images/deposit/Tether_BEP20_USDT.svg";
//       case "TRC20 USDT":
//         return "/assets/images/deposit/Tether_TRC20_USDT.svg";
//       default:
//         return "/assets/images/deposit/Tether.svg";
//     }
//   };

//   const filteredWallets = chainWalletDetail.filter(
//     (item) => item.cointype === COIN_TYPE
//   );

//   return (
//     <>
//       <div id="layout-wrapper">
//         {loading && <Loader />}
//         <Topbar />
//         <Sidebar />
//         <div className="main-content">
//           <div className="page-content">
//             <div className="container-fluid">
//               <div className="row">
//                 <div className="col-12">
//                   <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                     <h2 className="fw-700 mb-sm-0">Withdraw</h2>
//                   </div>
//                 </div>
//               </div>
//               <div className="row justify-content-center">
//                 <div className="col-12">
//                   <div className="card">
//                     <div className="card-body">
//                       <div className="">
//                         <ul
//                           className="nav nav-pills bg-light rounded transfer_tab"
//                           role="tablist"
//                         >
//                           <li className="nav-item">
//                             <a
//                               className="nav-link active"
//                               data-bs-toggle="tab"
//                               href="#transfer_details"
//                               role="tab"
//                             >
//                               Transfer Details
//                             </a>
//                           </li>
//                           <li className="nav-item">
//                             <a
//                               className="nav-link"
//                               data-bs-toggle="tab"
//                               href="#confirm_Transfer"
//                               role="tab"
//                             >
//                               Confirm Transfer
//                             </a>
//                           </li>
//                         </ul>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-12">
//                   <div className="card">
//                     <div className="card-body">
//                       <div className="tab-content mt-4">
//                         <div
//                           className="tab-pane active"
//                           id="transfer_details"
//                           role="tabpanel"
//                         >
//                           <div className="row">
//                             <div className="col-12 mb-3">
//                               <div className="hstack justify-content-between gap-2 flex-wrap">
//                                 <img
//                                   src={getCoinImage(COIN_TYPE)}
//                                   alt="product-img"
//                                   title="product-img"
//                                   width={50}
//                                 />
//                                 <button
//                                   type="Submit"
//                                   className="btn btn-primary px-4"
//                                   onClick={() => navigate("/withdraw")}
//                                 >
//                                   Change Payment Method
//                                 </button>
//                               </div>
//                             </div>
//                             <div className="col-lg-12 mb-4">
//                               <div className="d-flex gap-3 align-items-center flex-wrap">
//                                 <div className="text-primary">
//                                   <h4 className="card-title mb-0">
//                                     Payment Process{" "}
//                                   </h4>
//                                 </div>
//                               </div>
//                               <div className="d-flex gap-3 align-items-center flex-wrap mt-3">
//                                 <div className="text-primary">
//                                   <h4 className="card-title mb-0">
//                                     Currency
//                                   </h4>
//                                 </div>
//                                 <div className="form-check form-check-inline">
//                                   <input
//                                     className="form-check-input"
//                                     type="radio"
//                                     name=""
//                                     id="inlineRadio2"
//                                     defaultValue="option2"
//                                     defaultChecked={true}
//                                   />
//                                   <label
//                                     className="form-check-label"
//                                     htmlFor="inlineRadio2"
//                                   >
//                                     USDT
//                                   </label>
//                                 </div>
//                               </div>
//                             </div>
//                             <div className="col-xl-6 col-lg-12 mb-3">
//                               <div>
//                                 <label className="form-label">
//                                   Payment Method
//                                   <span className="text-danger">*</span>
//                                 </label>
//                                 <input
//                                   type="text"
//                                   className="form-control"
//                                   value={paymentMethod}
//                                   disabled
//                                 />
//                               </div>
//                             </div>
//                             <div className="col-xl-6 mb-3">
//                               <div>
//                                 <label className="form-label">
//                                   From Account<span className="text-danger">*</span>
//                                 </label>
//                                 <select
//                                   className="form-select"
//                                   name="fromAccount"
//                                   value={fromAccount}
//                                   onChange={handleChange}
//                                   disabled={isLocked}
//                                 >
//                                   <option value="" disabled hidden>Select From Account</option>
//                                   {filteredWallets.length > 0 ? (
//                                     filteredWallets.map((item, index) => (
//                                       <option key={index} value={item.address}>
//                                         {item.cointype} - Balance: {item.balance}
//                                       </option>
//                                     ))
//                                   ) : (
//                                     <option value="" disabled>No Account Found</option>
//                                   )}
//                                 </select>
//                                 {errors.fromAccount && (
//                                   <p className="text-danger">{errors.fromAccount}</p>
//                                 )}
//                               </div>
//                             </div>
//                             <div className="col-xl-6 mb-3">
//                               <div>
//                                 <label className="form-label">
//                                   Amount (In USD)
//                                   <span className="text-danger">*</span>
//                                 </label>
//                                 <input
//                                   className="form-control"
//                                   type="text"
//                                   placeholder="Amount (In USD)"
//                                   name="amount"
//                                   value={amount}
//                                   onChange={handleChange}
//                                   disabled={isLocked}
//                                 />
//                                 {errors.amount && (
//                                   <p className="text-danger">{errors.amount}</p>
//                                 )}
//                               </div>
//                             </div>
//                             <div className="col-xl-6 mb-3">
//                               <div>
//                                 <label className="form-label">
//                                   To External Wallet Address{" "}
//                                   <span className="text-danger">*</span>
//                                 </label>
//                                 <input
//                                   className="form-control"
//                                   type="text"
//                                   placeholder="Wallet Address"
//                                   name="address"
//                                   value={address}
//                                   onChange={handleChange}
//                                   disabled={isLocked}
//                                 />
//                                 {errors.address && (
//                                   <p className="text-danger">{errors.address}</p>
//                                 )}
//                               </div>
//                             </div>
//                             {showOtp && (
//                               <div className="col-xl-6 mb-3">
//                                 <label className="form-label">Enter OTP <span className="text-danger">*</span></label>
//                                 <input
//                                   className="form-control"
//                                   type="text"
//                                   placeholder="Enter OTP"
//                                   name="otp"
//                                   value={otp}
//                                   onChange={handleChange}
//                                   maxLength={6}
//                                 />
//                                 {errors.otp && (
//                                   <p className="text-danger">{errors.otp}</p>
//                                 )}
//                               </div>
//                             )}
//                             <div className="col-12 mb-3">
//                               {!showOtp ? (
//                                 <button className="btn btn-primary" onClick={beforeWithdraw}>
//                                   Submit
//                                 </button>
//                               ) : (
//                                 <button className="btn btn-success" onClick={createWithdrawRequest}>
//                                   Confirm Withdrawal
//                                 </button>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                         <div
//                           className="tab-pane"
//                           id="confirm_Transfer"
//                           role="tabpanel"
//                         >
//                           <div className="row">
//                             <div className="col-xl-6">
//                               <h4 className="card-title mb-4">
//                                 Other Details
//                               </h4>
//                               <div className="card p-3">
//                                 <h4 className="card-title text-primary pb-2 border-bottom">
//                                   QR code
//                                 </h4>
//                                 <img
//                                   src="assets/images/qr_img.png"
//                                   alt=""
//                                   width={300}
//                                   className="qr_img"
//                                 />
//                               </div>
//                             </div>
//                             <div className="col-xl-6">
//                               <h4 className="card-title mb-4">
//                                 Transfer Details
//                               </h4>
//                               <div className="table-responsive">
//                                 <table className="table border align-middle mb-0 table-nowrap">
//                                   <tbody>
//                                     <tr>
//                                       <th>Commission</th>
//                                       <td className="bg-light-subtle">
//                                         72 Hours
//                                       </td>
//                                     </tr>
//                                     <tr>
//                                       <th>Withdrawal Processing Time</th>
//                                       <td className="bg-light-subtle">
//                                         24 Hours
//                                       </td>
//                                     </tr>
//                                     <tr>
//                                       <th>Currencies</th>
//                                       <td className="bg-light-subtle">USD</td>
//                                     </tr>
//                                     <tr>
//                                       <th>Minimum Withdrawal</th>
//                                       <td className="bg-light-subtle">20</td>
//                                     </tr>
//                                     <tr>
//                                       <th>Maximum Withdrawal</th>
//                                       <td className="bg-light-subtle">
//                                         10000
//                                       </td>
//                                     </tr>
//                                   </tbody>
//                                 </table>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <Footer />
//         </div>
//       </div >
//     </>
//   );
// }
